export default "__VITE_ASSET__DCwMu3Oz__"